module.exports = __webpack_public_path__ + "img/6.5075a5ef.jpg";